<template>
  <div class="popup">
    <div class="popup__bg" @click="$emit(`openClick`)"></div>
    <div class="popup__inner" v-if="innerType">
      <div class="popup__title">삭제되었습니다.</div>
      <div class="popup__under">
        <button class="popup__button" @click="$emit(`openClick`)">확인</button>
      </div>
    </div>
    <div class="popup__inner" v-else-if="checkType">
      <div class="popup__title" v-text="contents"></div>
      <div class="popup__under">
        <button class="popup__button" @click="$emit(`openClick`)">확인</button>
      </div>
    </div>
    <div class="popup__inner" v-else-if="logoutType">
      <div class="popup__title">로그아웃하시겠습니까?</div>
      <div class="popup__under">
        <button class="popup__button" @click="$emit(`buttonClick`)">확인</button
        ><button
          class="popup__button popup__button--delete"
          @click="$emit(`openClick`)"
        >
          취소
        </button>
      </div>
    </div>
    <div class="popup__inner" v-else>
      <div class="popup__title">삭제하겠습니까?</div>
      <div class="popup__under">
        <button class="popup__button" @click="$emit(`buttonClick`)">확인</button
        ><button
          class="popup__button popup__button--delete"
          @click="$emit(`openClick`)"
        >
          취소
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PopupModal',
  props: ['innerType', 'contents', 'checkType', 'logoutType'],
  emits: ['openClick', 'buttonClick'],
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.popup,
.popup__bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.popup {
  &__bg {
    background: rgba(0, 0, 0, 0.5);
  }
  &__inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    min-width: 400px;
    height: 200px;
    min-height: 200px;
    background: #fff;
    border-radius: 15px;
    text-align: center;
    font-size: 14px;
    z-index: 999;
    padding: 30px;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  &__title {
    font-size: 20px;
    color: #2f2f2f;
  }
  &__button {
    height: 45px;
    margin: 0 5px;
    padding: 0 50px;
    background: #4087de;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    color: #fff;
    cursor: pointer;

    &--delete {
      background: #fff;
      color: #1f3d687c;
      border: 2px solid #1f3d6825;
      font-weight: 600;
    }
  }
}
</style>
